import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import routes from './config.js'
Vue.use(VueHead)
Vue.use(VueRouter)

export default new VueRouter({
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }

    let position = {
      x: 0,
      y: 0
    }
    if (to.path === '/') {
      position.y = +sessionStorage.getItem('scrollTop') || 0
    }
    return position
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js